import { useReactiveVar } from "@apollo/client";
import React, { FC } from "react";
import ReactAudioPlayer from "react-audio-player";
import { curEpisodeVar } from "../apollo";

export const PlayBar: FC = () => {
  console.log(useReactiveVar(curEpisodeVar));
  const episode = useReactiveVar(curEpisodeVar);

  return (
    <div className="sticky top-0 bg-gray-900 flex border-b-2 border-gray-800 py-2 px-1 z-20">
      <div className="flex justify-center items-center relative md:w-4/5 mx-auto">
        <div className="text-center">
          <div>
            <ReactAudioPlayer src={episode.fileUrl} autoPlay controls />
            <div className="text-gray-300 mt-2 font-bold">{episode.title}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
